import { useEffect } from 'react'
import { withRouter } from 'react-router-dom'

const RedirectToHome = ({ history }) => {
  useEffect(() => {
    history.push('/')
  }, [])

  return null
}


export default withRouter(RedirectToHome)


// WEBPACK FOOTER //
// ./src/pages/redirect-to-home.js